/**
 * ChatInfoRemapper
 *
 * Maps ChatInfoDto (data layer) → ChatInfoEntity (domain).
 * Flutter source: lib/data/models/chat_info.dart
 */
import type { ChatInfoDto } from '@/data/dtos/info/chatInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { ChatInfoEntity } from '@/domain/entities/info/chatInfoEntity';

export class ChatInfoRemapper {
  static fromDto(dto: ChatInfoDto): ChatInfoEntity {
    return { ...dto };
  }

  static fromJson(data: JsonObject): ChatInfoDto {
    return {
      name: data['name'] as string | undefined,
      description: data['description'] as string | undefined,
    };
  }

  static fromJsonList(dataList: JsonObject[]): ChatInfoDto[] {
    return dataList.map(ChatInfoRemapper.fromJson);
  }
}
